import { RecipeFields } from 'config/recipes';

import TitleInputDescription from './descriptions/TitleInputDescription';
import IngredientsDescription from './descriptions/IngredientsDescription';
import TimeToPrepareInputDescription from './descriptions/TimeToPrepareInputDescription';
import DirectionsInputDescription from './descriptions/DirectionsInputDescription';
import AdditionalDataInputDescription from './descriptions/AdditionalDataInputDescription';

const mapStepToDescription = (step) => {
  if (step === RecipeFields.title) return TitleInputDescription;
  if (step === RecipeFields.ingredients) return IngredientsDescription;
  if (step === RecipeFields.timeToPrepare) return TimeToPrepareInputDescription;
  if (step === RecipeFields.directions) return DirectionsInputDescription;
  if (step === RecipeFields.additionalData)
    return AdditionalDataInputDescription;

  throw new Error('step is invalid');
};

export default mapStepToDescription;
